import { Behavior, StrictBehavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';
import {
  GLOBAL_KEY_APPROVE_ME_FUNDING_APP_ID,
  GLOBAL_KEY_APPROVE_ME_FUNDING_APP,
  GLOBAL_KEY_APPROVE_ME_FUNDING_RESULT,
  GLOBAL_KEY_APPROVE_ME_CUSTOMER_FIRST_NAME,
} from './constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GLOBAL_CONTEXT_KEY_APPROVAL_AMOUNT } from '../application/constants';

@Injectable()
class SubmitApplicationBehavior extends StrictBehavior {
  static readonly DESCRIPTION = 'The behavior to save the application';

  static readonly GLOBAL_OUTPUT_PROPS = {
    error: {
      type: 'Error',
      name: 'error',
      friendlyName: 'Error',
      description: 'An object containing an error',
    },
    fundingApplicationResult: {
      name: 'fundingApplicationResult',
      type: 'number',
      description: 'The returned funding application results',
    },
  };

  // FOR TESTING PURPOSES WE ARE GOING TO SET REQUIRED TO FALSE
  // AFTER TESTING MAKE SURE THESE ARE TRUE
  static readonly GLOBAL_INPUT_PROPS = {
    fundingApplicationId: {
      required: false,
      name: GLOBAL_KEY_APPROVE_ME_FUNDING_APP_ID,
      type: 'number',
      description: 'The current funding application id',
    },
    fundingApplication: {
      required: false,
      name: GLOBAL_KEY_APPROVE_ME_FUNDING_APP,
      type: 'object',
      description: 'The current funding application',
    },
  };

  static readonly ARGS = {
    url: {
      required: false,
      name: 'url',
      type: 'string',
      description:
        'The Approve.Me Orchestrator URL, if null will default to QA',
      default: 'https://vdc-qaswebapp08.stormwind.local/AppMeOrchestrator',
    },
  };

  static readonly VERSION = '1.0.0';

  constructor(public http: HttpClient) {
    super();
  }
  async executeBehavior(
    args: { url: string },
    context: BehaviorContext
  ): Promise<any> {
    if (!args || !args.url) {
      args = {
        url: SubmitApplicationBehavior.ARGS.url.default,
      };
    }

    const fundingAppId = context.get(GLOBAL_KEY_APPROVE_ME_FUNDING_APP_ID);
    const fundingApp = context.get(GLOBAL_KEY_APPROVE_ME_FUNDING_APP);

    // CURRENTLY MOCKING... NOT REAL CALL YET
    const payload: any = {
      ...fundingApp,
      fundingAppId,
      StoreSlug: '128396',
      MerchantSlug: 'Forge',
      Mocking: {
        ServicesToMock: ['Approve.Me.Microservice.Orchestrator'],
        FundingApplicationId: fundingAppId,
        ApprovalAmount: 2018.01,
        DecisionResultCode: 'Approve',
        FinanceOptions: [
          {
            SourceLenderName: 'Lender One',
            ApprovalAmount: 2018.01,
            DecisionResultCode: 'Approve',
          },
        ],
        SourceReferenceId: 'askjdhaslkdj',
        ResponseSTatus_ErrorCode: '',
      },
    };

    try {
      const result = await this.http
        .post<any>(`${args.url}/submitApplication`, payload)
        .toPromise();

      context.set(
        GLOBAL_KEY_APPROVE_ME_FUNDING_APP_ID,
        result.fundingApplicationId
      );

      context.set(GLOBAL_KEY_APPROVE_ME_FUNDING_RESULT, result);
      context.set(GLOBAL_CONTEXT_KEY_APPROVAL_AMOUNT, result.approvalAmount);

      // TODO: we need a more generic way to store this.
      context.set(
        GLOBAL_KEY_APPROVE_ME_CUSTOMER_FIRST_NAME,
        fundingApp.PrimaryCustomer_FirstName
      );
    } catch (error) {
      context.set('error', error);
    }
  }
}

export { SubmitApplicationBehavior };
